// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__35shF","color":"styles_color__3xOTB","value":"styles_value__2B4po"};